export enum ConveyanceAttachmentType {
  Acte_de_vente = 'Acte_de_vente',
  Contrat_de_bail = 'Contrat_de_bail',
  Quitus = 'Quitus',
  Reçu = 'Reçu',
  Autre = 'Autre',
}
